module.exports = __webpack_public_path__ + "img/preview_dy1.49ea5c53.png";